export enum StoryCardLayout {
  COVER,
  VIDEO,
  ANIMATION,
  CONTENT,
  HIGHLIGHT,
  QUIZ,
  QUIZGAME
}
